import { Styles } from '@monkvision/types';

export const styles: Styles = {
  wrapper: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    inset: '0 0 0 0',
    gap: '30px',
  },
};
